import { render, staticRenderFns } from "./EsSorter.vue?vue&type=template&id=b2ec3ec4&"
import script from "./EsSorter.vue?vue&type=script&lang=js&"
export * from "./EsSorter.vue?vue&type=script&lang=js&"
import style0 from "./EsSorter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports